































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import SUpload from './SUpload.vue';
import SFilePreviews from './SFilePreviews.vue';
import { isEqual } from 'lodash';

type GQLAttachment = {
  id: string | null;
  signedBlobId: string | null;
  fileName: string | null;
  contentType: string | null;
  url: string | null;
  _destroy?: boolean;
}

type Attachment = File | GQLAttachment;

@Component({
  components: {
    SUpload,
    SFilePreviews,
  },
})
export default class SMultipleAttachments extends Vue {
  @Prop({ type: Array, required: true }) private value!: Array<Attachment>;
  private internalValue = SMultipleAttachments.valueToInternal(this.value);
  private sUploadValue: Array<File> | null = null;

  @Prop({ type: Boolean, default: false }) private fullWidth!: boolean;

  @Watch('value', { deep: true })
  private updateInternalValue() {
    const newInternalValue = SMultipleAttachments.valueToInternal(this.value);
    if (!isEqual(this.internalValue, newInternalValue)) {
      this.internalValue = newInternalValue;
    }
  }

  @Watch('internalValue', { deep: true })
  private updateValue(): void {
    this.$emit('input', this.internalValue);
  }

  @Watch('sUploadValue', { deep: true })
  private addFiles() {
    if (!this.sUploadValue) return;

    this.internalValue.push(...this.sUploadValue);
    this.sUploadValue = null;
  }

  private removeFile(file: Attachment) {
    if ('signedBlobId' in file) {
      this.$set(file, '_destroy', true);
    } else {
      this.internalValue.splice(this.internalValue.indexOf(file), 1);
    }
  }

  private get notDeletedFiles() {
    return this.internalValue.filter(file => !('_destroy' in file) || !file._destroy);
  }

  private static valueToInternal(value: Array<Attachment>) {
    return [ ...value ];
  }
}
